import type { SVGProps } from 'react';
const DawnFlagBA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-BA_svg__a)">
      <path fill="#0B36B2" d="M0 0h22v16H0z" />
      <g filter="url(#dawn-flag-BA_svg__b)">
        <path fill="#FFD045" fillRule="evenodd" d="M17.81 16V0h-11z" clipRule="evenodd" />
      </g>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m13.619 14.933-.74.221.216-.754-.217-.754.74.22.742-.22-.217.754.217.754zM11.524 11.733l-.74.221L11 11.2l-.217-.754.741.22.741-.22-.217.754.217.754zM9.428 8.533l-.74.221L8.905 8l-.217-.754.74.22.741-.22L9.952 8l.217.754zM7.334 5.333l-.741.221.217-.754-.217-.754.74.22.742-.22-.217.754.217.754zM5.238 2.133l-.74.221.216-.754-.217-.754.741.22.74-.22-.216.754.217.754z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="dawn-flag-BA_svg__b"
        width={11}
        height={16}
        x={6.81}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_278" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_278" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagBA;
